import {
  CHANGELOG_FALLBACK_SOURCES,
  type ChangelogProductId,
} from '@/lib/changelog/changelog-sources';
import type { ChangelogEntry } from '@/lib/changelog/changelog-types';

export function getChangelogEntriesForProduct(product: ChangelogProductId): ChangelogEntry[] {
  return CHANGELOG_FALLBACK_SOURCES[product].entries;
}

export function changelogPainelBaseHref(product: ChangelogProductId): string {
  return `/painel/changelog/${product}`;
}

export function changelogPainelPageHref(
  product: ChangelogProductId,
  page: 'overview' | 'versions' | 'categories'
): string {
  return `${changelogPainelBaseHref(product)}/${page}`;
}

export function changelogVersionHref(product: ChangelogProductId, version: string): string {
  return `/painel/changelog/${product}/versions/${encodeURIComponent(version)}`;
}

export function changelogPublicHref(product: ChangelogProductId): string {
  return product === 'ajuda' ? '/changelog?produto=ajuda' : '/changelog';
}

export function parseChangelogProductFromPath(pathname: string): ChangelogProductId | null {
  const match = pathname.match(/^\/painel\/changelog\/(xat|ajuda)(?:\/|$)/);
  return match ? (match[1] as ChangelogProductId) : null;
}
